/** @format */

import React, { useState, useEffect } from "react";
import Image from "next/image";
import Head from "next/head";
import { useRouter } from "next/router";
import { Container } from "@material-ui/core";
import SearchBar from "../../components/SearchBar";
import ItemCarousel from "../../components/ItemCarousel";
import Error from "next/error";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import styles from "../../styles/stadt.module.scss";

export default function Stadt({ errorCode, stadt }) {
  const router = useRouter();
  const [options, setOptions] = useState([]);

  const carouselSettings = {
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    variableWidth: true,
    draggable: true,
    useTransform: false,
    autoplay: true,
    autoplaySpeed: 10000,
  };
  /* Einrichtungen in der Nähe des Ortes anfordern */
  useEffect(() => {
    if (!errorCode) {
      fetch(
        `/api/pflegeheime?&ort=${stadt.data.name}&lat=${stadt.data.location.coordinates[1]}&lng=${stadt.data.location.coordinates[0]}&rng=5&ps`
      )
        .then((res) => res.json())
        .then((data) => {
          setOptions(data.data);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, []);
  if (errorCode) {
    return <Error statusCode={errorCode} />;
  }
  return (
    <div>
      <Head>
        <title>[200+] Pflegeheime in {stadt.data.name} finden</title>
        <meta
          name="description"
          content="Freie Vollstationäre, Kurzzeit-, Tages- und ambulante Pflegeplätze finden ᐅ Finde aus über 25.000 Einrichtungen die Besten Pflegeplätze in deiner Nähe und Vergleiche die jeweiligen Preise, Bewertungen und vieles mehr!"
        />
        <link
          rel="canonical"
          href={`https://hilfebeipflege.de/orte/${stadt.data.link}`}
        />

        <link
          rel="stylesheet"
          href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
        />
        <link
          rel="stylesheet"
          href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"
        />
      </Head>
      <Container maxWidth="lg">
        <div style={{ display: "flex", flexDirection: "row", padding: "1rem" }}>
          <div
            style={{
              width: "100%",
              borderRadius: 12,
              boxShadow: "0px 6px 20px rgba(0, 0, 0, 0.2)",
              marginRight: "-100px",
              marginTop: "50px",
              zIndex: "10",
              height: "450px",
              background: "#fafafa",
              padding: "32px",
            }}
          >
            <h1 style={{ fontSize: "32px", lineHeight: "36px" }}>
              Pflegeplätze in {stadt.data.name}
            </h1>
            <p
              style={{ color: "#717171", fontSize: "16px", lineHeight: "20px" }}
            >
              Finden und buchen Sie Ihren geeigneten Pflegeplatz mit CareNext.
            </p>
            <div>
              <SearchBar
                vertical={true}
                query={router.query}
                ort={stadt.data}
              />
            </div>
          </div>
          <div className={styles.container}>
            <div className={styles.image}>
              <Image
                src="/images/nursing-home.jpg"
                className="img-ort"
                alt="Picture of the author"
                layout="fill"
                objectFit="cover"
                priority={true}
              />
            </div>
          </div>
        </div>
        <div style={{ margin: "10px", padding: "10px" }}>
          <h1
            style={{ fontSize: "32px", lineHeight: "36px", marginTop: "10px" }}
          >
            Erstklassige Pflegeheime in {stadt.data.name}
          </h1>
          <Carousel
            autoPlay
            autoPlaySpeed={10000}
            infinite
            responsive={{
              superLargeDesktop: {
                breakpoint: { max: 4000, min: 1024 },
                items: 4,
              },
              desktop: {
                breakpoint: { max: 1024, min: 768 },
                items: 3,
              },
              tablet: {
                breakpoint: { max: 768, min: 640 },
                items: 2,
              },
              mobile: {
                breakpoint: { max: 640, min: 0 },
                items: 1,
              },
            }}
            itemClass="px-4"
          >
            {options.map((pflegeheim, index) => (
              <ItemCarousel ph={pflegeheim} />
            ))}
          </Carousel>
        </div>
      </Container>
    </div>
  );
}
export async function getServerSideProps(context) {
  const server = process.env.SERVER;
  const res = await fetch(`${server}/api/orte/${context.params.stadt}`);
  const errorCode = res.ok ? false : res.status;
  if (errorCode) {
    context.statusCode = errorCode;
  }
  const stadt = await res.json();
  return {
    props: {
      errorCode,
      stadt,
    },
  };
}
/* export const getStaticProps = async (context) => {
    const res = await fetch(`http://localhost:3000/api/orte/${context.params.ort}`)
    const data = await res.json()
    const ort = data.data
    return {
        props: {
            ort
        }
    }
}
export const getStaticPaths = async () => {
    const res = await fetch(`http://localhost:3000/api/orte`)
    const data = await res.json()
    const orte = data.data.map(ort => ort.link)
    const paths = orte.map(name => ({ params: { ort: name } }))
    
    return {
        paths,
        fallback: false
    }
} */
